import { ridSegment } from '@krp/client-runtime'

/**
 * Адреса цен и остатков native-контракта 1С v1 (срез B4a):
 * `/api/onec/v1/resources/{rid}/…`. Литерал `/api/` законен только здесь.
 */
const base = (resourceId: string) => `/api/onec/v1/resources/${ridSegment(resourceId)}`
const key = (value: string) => encodeURIComponent(value)

export const ONEC_PRICING_URLS = {
  stockByRefKeys: (resourceId: string) => `${base(resourceId)}/catalog/products/stock-by-refkeys`,
  pricesByRefKeys: (resourceId: string) => `${base(resourceId)}/catalog/products/prices-by-refkeys`,
  productStock: (resourceId: string, refKey: string) => `${base(resourceId)}/catalog/products/${key(refKey)}/stock`,
  productPrices: (resourceId: string, refKey: string) => `${base(resourceId)}/catalog/products/${key(refKey)}/prices`,
  discrepancies: (resourceId: string) => `${base(resourceId)}/catalog/retail-price-discrepancies`,
  comparisonFilter: (resourceId: string) => `${base(resourceId)}/catalog/price-comparison-filter`,
  priceList: (resourceId: string) => `${base(resourceId)}/catalog/price-list`,
  priceRecords: (resourceId: string) => `${base(resourceId)}/catalog/price-list/records`,
  /** RP-FB39: виды цен базы (справочник). */
  priceTypes: (resourceId: string) => `${base(resourceId)}/catalog/price-list/types`,
  priceType: (resourceId: string, typeKey: string) => `${base(resourceId)}/catalog/price-list/types/${key(typeKey)}`,
  priceTypeMark: (resourceId: string, typeKey: string) => `${base(resourceId)}/catalog/price-list/types/${key(typeKey)}/deletion-mark`,
} as const
